import * as React from "react";
import {ICustomerPortalService, Image, ImageRequest, Types, ValuableItem} from "@falcon/services";
import {ImagePanel} from "./ImagePanel";
import {lazyInject} from "@athena-portal/core";
import {Overlay} from "@athena-portal/components";
// @ts-ignore
import imageCompression from "browser-image-compression";

interface IProps {
    item: ValuableItem
}

interface IState {
    images: Image[],
    imageError: Record<string, boolean>,
    showOverlay: boolean
}

export default class ImageUploadPanel extends React.Component<IProps, IState> {

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    constructor(props: IProps) {
        super(props);

        this.state = {
            images: [],
            imageError: {},
            showOverlay: false
        };
    }

    public componentDidMount(): void {
        this.getImages();
    }

    public render(): React.ReactNode {
        return (
            <>
                <div className="photo my-3">
                    {this.renderImages()}
                    {this.state.images.length < 2 && this.renderImageUploader()}
                    <Overlay show={this.state.showOverlay}/>
                </div>
                {this.state.imageError[this.props.item.id] && (
                    <div className="invalid-feedback d-block">
                        <b>Oops, you’ve uploaded invalid image type. Try again using .jpg, .jpeg, .png</b>
                    </div>
                )}
            </>
        );
    }

    private renderImages = (): React.ReactNode => {
        const {images} = this.state;
        if (this.state.images.length > 0) {
            return (
                <div className="p-2">
                    {...images.map((image: Image, index: number) => (
                        <div key={index}>
                            {index > 0 && <div className="dashed-10 my-2"/>}
                            <ImagePanel image={image} onRemove={this.handleImageRemove}/>
                        </div>
                    ))}
                </div>
            )
        } else {
            return <></>
        }
    };

    private renderImageUploader = (): React.ReactNode => {
        return (
            <>
                <div className="mt-2 mb-4 p-3"><b>Upload up to 2 photos / receipts of your item</b></div>
                <div>
                    <label htmlFor={`item-${this.props.item.valuableItemId}-image-upload-input`}>
                        <img src="/img/Flow-plus.svg" alt="Upload image icon"/>
                    </label>
                    <input type="file"
                           id={`item-${this.props.item.valuableItemId}-image-upload-input`}
                           accept=".jpg, .jpeg, .png"
                           className="d-none"
                           onChange={this.getFile}/>
                </div>
            </>
        )
    };

    private getFile = async (event: any) => {
        const imageFile = event.target.files[0];
        const objectId: string = this.props.item.id;
        this.setState({imageError: {[objectId]: false}})
        if (imageFile) {
            this.setState({showOverlay: true});
            let compressedFile = null;
            try {
                compressedFile = await imageCompression(imageFile, {
                    maxSizeMB: 1,
                    maxWidthOrHeight: 1920,
                    useWebWorker: false
                });
            } catch (e) {
                this.setState({showOverlay: false, imageError: {[objectId]: true}})
            }
            if (compressedFile) {
                const reader = new FileReader;
                reader.readAsDataURL(compressedFile);
                reader.onload = () => {
                    const request: ImageRequest = new ImageRequest();
                    request.imageBase64 = reader.result as string;
                    request.objectId = objectId;
                    this.customerPortalService.createValuableItemImage(request).subscribe(() => this.getImages());
                }
            }
        }
    };

    private handleImageRemove = (imageId: string) => {
        this.customerPortalService.deleteValuableItemImage(imageId).subscribe(() => this.getImages());
    };

    private getImages = (): void => {
        this.setState({showOverlay: true});
        this.customerPortalService.getValuableItemImages(this.props.item.id).subscribe((images: Image[]) => {
            images && this.setState({images, showOverlay: false});
        });
    }
}
